import { useMutation } from "@tanstack/react-query";
import {
  login as firebaseApi,
  verifyUserAndRetrieve,
} from "../../services/apiAuth";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../contexts/UserContext"; // adjust the path as necessary
import toast from "react-hot-toast";

export function useLogin() {
  const navigate = useNavigate();
  const { setUserDetails } = useContext(UserContext);

  const { mutate: login, isLoading } = useMutation({
    mutationFn: async ({ email, password }) => {
      const { userEmail, userToken } = await firebaseApi({ email, password });
      const userDetails = await verifyUserAndRetrieve(userToken);

      return { userEmail, userToken, ...userDetails };
    },

    onSuccess: (apiResponse) => {
      const { data } = apiResponse;
      const { userAuth, wiMuleToken, wiMuleTokenTimestamp } = data;

      console.log("Data from Firebase Login", userAuth, wiMuleToken);

      const userDetails = {
        email: userAuth?.email || "", // Avoids undefined issues
        token: userAuth?.userToken || "", // Ensures a valid token assignment
        userName: userAuth?.userName || "",
        userCompany: userAuth?.company || "",
        userAccessLevel: userAuth?.accessLevel || "",
        userImage: userAuth?.image || "",
        userWiMuleToken: wiMuleToken || "",
        userWiMuleTokenTimestamp: wiMuleTokenTimestamp || "",
      };

      console.log("WiMule User Details BEFORE set:", userDetails);

      // 🔥 Ensure State Updates Immediately
      setUserDetails((prev) => {
        console.log("Previous User Details:", prev);
        return { ...prev, ...userDetails };
      });

      console.log("WiMule User Details AFTER set:", userDetails);
    },
    onError: (err) => {
      console.log(err.message);
      toast.error("The provided email and/or password is incorrect");
    },
  });

  return { login, isLoading };
}
